import { memo } from 'react'
import DataTable from 'src/templates/members/data-table'
import { api } from 'src/api/root'
import { LayerItem } from 'src/types/layer'
import { useColumns } from './colums'

interface LayersTableProps {
  layers: LayerItem[]
  isLoading: boolean
  hasNextPage?: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

// Columns are rebuilt on every render and flexRender remounts their cells, so typing and upload progress must not re-render this.
const LayersTable = memo(({ layers, isLoading, hasNextPage, isFetchingNextPage, onLoadMore }: LayersTableProps) => {
  const { mutate: deleteLayer } = api.layer.delete.useMutation()
  const { mutate: updateLayer } = api.layer.updateName.useMutation()
  const { mutateAsync: updateOrderAsync } = api.layer.updateOrder.useMutation()

  const handleDelete = (fileId: string) => deleteLayer(fileId)

  const handleUpdateName = async (id: string, newName: string) => {
    await updateLayer({ fileId: id, fileName: newName })
  }

  const handleUpdateOrder = async (id: string, orderNumber: number | null) => {
    await updateOrderAsync({ fileId: id, orderNumber })
  }

  const columns = useColumns(handleDelete, handleUpdateName, handleUpdateOrder)

  return (
    <DataTable
      columns={columns}
      data={layers}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      onLoadMore={onLoadMore}
    />
  )
})

LayersTable.displayName = 'LayersTable'

export default LayersTable
